import { status } from "../_constants/commanLHd";
import { pageConstant } from "../_constants/pageConstant";

let initialState = {};

export function page(state = initialState, action) {
  switch (action.type) {
    case pageConstant.PAGE_REQUEST:
      return {
        ...state,
        page_status: status.IN_PROGRESS,
        page_data: null,
      };
    case pageConstant.PAGE_SUCCESS:
      return {
        ...state,
        page_status: status.SUCCESS,
        page_data: action.data,
      };
    case pageConstant.PAGE_FAILURE:
      return {
        ...state,
        page_status: status.FAILURE,
        page_data: action.data,
      };

    default:
      return state;
  }
}